import React from "react";
import { useState, useRef, useEffect } from "react";
import style from "./header_searchbar.module.css";
import { useNavigate } from "react-router-dom";
import { BiSolidDonateHeart } from "react-icons/bi";

const HeaderDonateButton = () => {

	const navigate = useNavigate();
	const handleClick = () => {
        
            let url = "/donate/payment";
            navigate(url);
        }
 return (	
	<div>
	 <button className = {style.searchButton} onClick = {handleClick}><BiSolidDonateHeart className="icon" style={{ fontSize: "2rem" }} /></button>
	</div>
);

}


export default HeaderDonateButton;
